module.exports = __webpack_public_path__ + "fonts/Inter-800-latin-ext76.ad4eb06.woff2";